<template>
  <v-container fluid>
    <v-row class="text-center">
      <v-col cols="12" class="pt-4">
        <p>Copyright © {{ year }} - Todos os direitos reservados. PEJA.</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'FooterCopyright',
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
